import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const AccountNumberConfirm = props => (
  <BaseInput
    name="accountNumberConfirm"
    label="Confirm Bank Account Number"
    type="tel"
    autoComplete="off"
    transparent
    maxLength="17"
    validate={val =>
      string()
        .required('Confirm Bank Account Number')
        .test(
          'match-account-number',
          'Oops! This entry doesnt match the entry above.',
          value => {
            if (value && value.length > 0) {
              return value === props?.accountNumber;
            }
            return false;
          }
        )
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

AccountNumberConfirm.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  accountNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

AccountNumberConfirm.defaultProps = {
  value: '',
  error: '',
  accountNumber: null
};

export default AccountNumberConfirm;
